var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect2, _g, _g2, _path12, _path13, _rect3, _rect4, _path14, _path15, _path16, _path17, _rect5, _path18, _path19, _rect6, _g3, _path20, _path21, _path22, _rect7, _g4, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradingBotLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 142,
    viewBox: "0 0 145 142",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35429 38.0537C6.7649 26.685 15.3941 17.7459 19.8141 13.6904C32.7723 4.50176 39.6515 3.51293 48.3284 2.26569L48.4991 2.24116C62.0121 0.29828 91.8303 0.477272 104.206 4.14715C119.676 8.73451 128.516 17.9092 133.74 27.4828C138.964 37.0564 144.991 52.2146 141.174 82.531C138.12 106.784 125.302 115.64 114.453 121.623L96.5716 130.798L75.0745 140.372C65.029 136.316 41.1207 126.051 25.8516 117.435C6.76514 106.665 3.1488 87.3178 2.14428 82.531C0.00968647 72.3591 1.75529 50.3108 4.35429 38.0537Z",
    fill: "url(#paint0_linear_1777_5756)",
    stroke: "black",
    strokeWidth: 1.36667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6449 82.3086H3.01953L3.62013 85.3535L4.42092 88.8045L5.62211 92.4584L7.22369 96.3153C17.9543 96.4777 26.3092 96.2476 27.4437 95.7063C29.5258 92.9456 29.0453 85.0829 28.6449 82.3086Z",
    stroke: "black",
    strokeWidth: 1.13889
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1057 34.7959C34.0179 25.1719 21.5914 18.8013 16.7734 17.2641C29.816 2.52405 46.1081 1.71125 62.0579 0.915526L62.4039 0.898261C75.4502 0.246789 99.6315 1.07579 111.989 6.91334C126.845 13.9308 135.075 26.5623 138.89 38.3917C142.704 50.2212 143.507 70.4716 141.901 80.697C139.999 92.8057 136.49 112.308 119.618 117.188C100.948 122.588 77.2594 120.783 57.3852 116.185C39.8053 112.118 37.9129 92.7444 37.1097 84.5224L37.1094 84.5197C36.3064 76.2992 38.7154 46.8258 36.1057 34.7959Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.36667
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85.2305,
    y: 94.5312,
    width: 18.9475,
    height: 4.88968,
    rx: 1.48056,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4921 89.3543C53.8429 82.5632 42.4603 81.876 37.25 82.4823C37.8512 94.205 38.6528 100.066 43.8631 107.343C48.0027 113.123 54.6845 116.034 61.6984 116.842V100.268C61.6984 93.5987 59.4941 91.0386 58.4921 89.3543Z",
    stroke: "black",
    strokeWidth: 1.36667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5259 36.7049C27.3361 33.4673 19.4754 29.0938 15.2081 26.9922L10.6602 39.2608C13.7595 39.6698 24.641 45.5656 29.8628 55.1079L32.0525 43.6912C31.9402 42.9528 31.5348 39.6751 29.5259 36.7049Z",
    fill: "#CAA2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7811 113.834L8.21484 97.2812L9.33817 99.357L10.622 101.592C12.3298 104.133 14.9419 108.053 19.2104 111.652C22.6261 114.531 25.3699 116.407 32.2014 119.625L40.4562 123.869L61.2373 124.48L84.4633 125.244L104.022 125.855L116.857 119.285L118.233 118.215C102.526 122.479 73.7448 120.78 57.1786 117.731L33.7811 113.834Z",
    fill: "#7057F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7786 126.926H62.3725L71.4766 136.4L49.7786 126.926Z",
    fill: "#383740"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0433 85.3633H6.6875L8.21559 90.09L25.5339 90.253C26.3489 89.2098 26.3829 86.5585 26.0433 85.3633Z",
    fill: "#826CF7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5288 127.539H65.8323L75.4492 137.93L52.5288 127.539Z",
    fill: "#634AE4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7773 124.48L105.705 126.556L98.6915 130.291L96.2869 131.536L94.6839 132.366L75.0465 141.289L65.6285 137.346L56.2106 132.988L38.7773 124.48Z",
    fill: "#7057F0",
    stroke: "black",
    strokeWidth: 0.911111
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7781 127.539H64.9977L74.2266 137.93L49.7781 127.539Z",
    fill: "#644AE7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1367,
    y: 44.4141,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1777_5756)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.905,
    cy: 60.1523,
    rx: 19.1003,
    ry: 12.9882,
    fill: "#832136"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1777_5756)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.9073,
    cy: 59.5399,
    rx: 12.0714,
    ry: 8.09854,
    fill: "#C31414"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6955 74.3633H85.8419V81.3922L74.6873 97.5893L54.2118 83.3786L44.5852 81.3922L38.3203 78.1833L39.6955 74.3633Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.075 44.4141H87.3697V35.3505L76.1793 14.4647L55.6379 32.789L45.9804 35.3505L39.6953 39.4882L41.075 44.4141Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4727,
    y: 46.2461,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 87.6719,
    y: 44.4141,
    width: 7.02892,
    height: 28.1157,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6916 73.5959L41.8313 69.1646L42.4426 71.4567L43.8173 73.1369L45.3453 74.0537L46.8733 74.5121L43.0263 77.172L39.6916 73.5959Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2885 74.3256L88.5019 68.2877L87.828 69.472L87.5224 71.0001L86.6983 72.5281L85.3832 73.5977L84.008 74.2089L82.7855 74.5145L81.5632 75.3942L86.6983 79.0789L91.2885 74.3256Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.883 74.0547H137.029V81.0836L125.875 97.2807L105.399 83.07L95.7727 81.0836L89.5078 77.8748L90.883 74.0547Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2625 44.1055H138.557L134.279 35.0419L119.915 17.9762L106.825 32.4804L97.1679 35.0419L90.8828 39.1796L92.2625 44.1055Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 89.6602,
    y: 45.9414,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.883 73.2912L93.0227 68.8599L93.634 71.152L95.0087 72.8322L96.5367 73.7491L98.0647 74.2075L94.2178 76.8673L90.883 73.2912Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140.544 74.2098L139.689 67.983L139.016 69.1674L138.71 70.6954L137.886 72.2234L136.571 73.293L135.195 73.9042L133.973 74.2098L132.751 75.0895L137.886 78.7742L140.544 74.2098Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 91.6445,
    y: 44.4141,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "black"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1777_5756)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.413,
    cy: 60.1523,
    rx: 19.1003,
    ry: 12.9882,
    fill: "#832136"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8289 44.412H119.76H134.124L136.416 46.5513L138.249 48.9961L138.555 42.2728L134.124 35.3484L118.996 17.0603L102.392 32.787L92.7343 35.3484L86.4492 39.4861L87.8289 44.412Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.883 74.3633H137.029V81.3922L125.875 97.5893L105.399 83.3786L95.7727 81.3922L89.5078 78.1833L90.883 74.3633Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4101 77.4606L96.9395 74.9087L95.8549 74.2915L94.4556 74.0116L93.0562 73.257L92.0767 72.0526L91.5169 70.7931L91.2371 69.6737L90.4315 68.5542L87.0571 73.257L91.4101 77.4606Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 87.9805,
    y: 45.3281,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1777_5756)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.72,
    cy: 59.8446,
    rx: 12.0714,
    ry: 8.09854,
    fill: "#C31414"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M137.793 43.9531L139.627 45.7868L141.46 59.2334V66.7207L141.155 72.2216L139.932 79.4033L133.056 76.5001L132.598 74.8193L134.89 73.7496L137.335 71.916V56.4829V48.9956L137.793 43.9531Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8824 72.0072C62.802 71.8456 62.7337 71.733 62.6853 71.6115C61.9899 69.845 61.2964 68.0774 60.6046 66.3087C59.2462 62.8515 57.8877 59.3959 56.5293 55.9417C55.3654 52.975 54.2027 50.0083 53.041 47.0416C53.0326 47.0251 53.0252 47.0079 53.019 46.9903C52.9771 46.8276 52.9364 46.6637 52.8945 46.4999C53.0551 46.4918 53.216 46.4967 53.3759 46.5144C54.8826 46.793 56.3861 47.0818 57.8918 47.3627C59.577 47.6759 61.2644 47.9813 62.9496 48.2946C64.0412 48.4975 65.1294 48.7137 66.2198 48.9166C67.4909 49.1552 68.763 49.3848 70.0341 49.62C70.6113 49.7315 71.1884 49.8351 71.7623 49.9544C71.8765 49.9831 71.9813 50.0415 72.0663 50.1239C73.6127 51.6042 75.1573 53.0865 76.7001 54.5705C76.8432 54.7088 76.8465 54.8113 76.7188 54.9685C73.4534 58.9927 70.1902 63.0187 66.9291 67.0466C65.6669 68.6073 64.4017 70.162 63.1336 71.7107C63.073 71.7932 63.0014 71.8734 62.8824 72.0072ZM62.7414 67.9395L62.8186 67.9206C62.8379 67.872 62.8527 67.8216 62.8626 67.7701C63.0418 66.2875 63.2206 64.8049 63.399 63.3223C63.6479 61.2222 63.8969 59.1231 64.1326 57.0218C64.1342 56.9522 64.1217 56.883 64.096 56.8184C64.0702 56.7538 64.0317 56.6952 63.9828 56.6462C63.6523 56.3385 63.2988 56.0576 62.9529 55.7667C60.5811 53.7765 58.209 51.7874 55.8365 49.7995C55.7769 49.7543 55.7147 49.7126 55.6503 49.6746L55.5876 49.7237L62.7414 67.9395ZM74.1811 55.8882C74.0637 55.8797 73.9459 55.8797 73.8286 55.8882C72.9265 56.052 72.0255 56.2226 71.1234 56.3876L67.7949 56.9962C67.1274 57.1177 66.4599 57.2437 65.7913 57.3618C65.5931 57.3964 65.4829 57.49 65.4609 57.7029C65.4356 57.9983 65.3926 58.2926 65.3574 58.588C65.198 59.9146 65.038 61.2407 64.8771 62.5665C64.7009 64.041 64.5254 65.515 64.3507 66.9887C64.311 67.3231 64.2813 67.6575 64.2471 67.9919L64.3253 68.0276L74.1811 55.8882ZM70.0242 51.1583L69.9592 51.0335L56.6846 48.561L56.6284 48.648C56.7066 48.707 56.7859 48.7594 56.8619 48.8274C57.5404 49.3937 58.2185 49.9615 58.8963 50.5307C60.7688 52.1014 62.6412 53.6687 64.4994 55.2505C64.7417 55.4568 64.8948 55.4389 65.125 55.2416C66.6604 53.9307 68.209 52.6331 69.751 51.3322C69.8381 51.2681 69.9294 51.21 70.0242 51.1583ZM74.3947 54.3576C74.3626 54.2982 74.3257 54.2416 74.2846 54.1882C73.4431 53.3767 72.5972 52.5662 71.7568 51.7525C71.6279 51.6288 71.5365 51.6511 71.4065 51.7614C70.2114 52.7725 69.0109 53.7769 67.8136 54.7857C67.4655 55.0789 67.1219 55.3787 66.776 55.6775L66.808 55.7477L74.3947 54.3576Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M114.132 72.0072C114.052 71.8456 113.984 71.733 113.935 71.6115C113.24 69.845 112.546 68.0774 111.855 66.3087C110.496 62.8515 109.138 59.3959 107.779 55.9417C106.615 52.975 105.453 50.0083 104.291 47.0416C104.283 47.0251 104.275 47.0079 104.269 46.9903C104.227 46.8276 104.186 46.6637 104.145 46.4999C104.305 46.4918 104.466 46.4967 104.626 46.5144C106.133 46.793 107.636 47.0818 109.142 47.3627C110.827 47.6759 112.514 47.9813 114.2 48.2946C115.291 48.4975 116.379 48.7137 117.47 48.9166C118.741 49.1552 120.013 49.3848 121.284 49.62C121.861 49.7315 122.438 49.8351 123.012 49.9544C123.126 49.9831 123.231 50.0415 123.316 50.1239C124.863 51.6042 126.407 53.0865 127.95 54.5705C128.093 54.7088 128.097 54.8113 127.969 54.9685C124.703 58.9927 121.44 63.0187 118.179 67.0466C116.917 68.6073 115.652 70.162 114.384 71.7107C114.323 71.7932 114.251 71.8734 114.132 72.0072ZM113.991 67.9395L114.069 67.9206C114.088 67.872 114.103 67.8216 114.113 67.7701C114.292 66.2875 114.471 64.8049 114.649 63.3223C114.898 61.2222 115.147 59.1231 115.383 57.0218C115.384 56.9522 115.372 56.883 115.346 56.8184C115.32 56.7538 115.282 56.6952 115.233 56.6462C114.902 56.3385 114.549 56.0576 114.203 55.7666C111.831 53.7765 109.459 51.7874 107.086 49.7995C107.027 49.7543 106.965 49.7126 106.9 49.6746L106.838 49.7237L113.991 67.9395ZM125.431 55.8882C125.314 55.8797 125.196 55.8797 125.079 55.8882C124.177 56.052 123.276 56.2226 122.373 56.3876L119.045 56.9962C118.377 57.1177 117.71 57.2437 117.041 57.3618C116.843 57.3964 116.733 57.49 116.711 57.7029C116.686 57.9983 116.643 58.2926 116.607 58.588C116.448 59.9146 116.288 61.2407 116.127 62.5665C115.951 64.0409 115.775 65.515 115.601 66.9887C115.561 67.3231 115.531 67.6575 115.497 67.9919L115.575 68.0276L125.431 55.8882ZM121.274 51.1583L121.209 51.0335L107.935 48.561L107.878 48.648C107.957 48.707 108.036 48.7594 108.112 48.8274C108.79 49.3937 109.469 49.9615 110.146 50.5307C112.019 52.1014 113.891 53.6687 115.749 55.2505C115.992 55.4568 116.145 55.4389 116.375 55.2416C117.91 53.9307 119.459 52.6331 121.001 51.3322C121.088 51.2681 121.179 51.21 121.274 51.1583ZM125.645 54.3576C125.613 54.2982 125.576 54.2416 125.535 54.1882C124.693 53.3767 123.847 52.5662 123.007 51.7525C122.878 51.6288 122.786 51.6511 122.657 51.7614C121.461 52.7725 120.261 53.7769 119.064 54.7857C118.716 55.0789 118.372 55.3787 118.026 55.6775L118.058 55.7477L125.645 54.3576Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1777_5756",
    x: 35.008,
    y: 36.3674,
    width: 59.7926,
    height: 47.5699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.39833,
    result: "effect1_foregroundBlur_1777_5756"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1777_5756",
    x: 45.4787,
    y: 44.0842,
    width: 38.859,
    height: 30.9098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.67861,
    result: "effect1_foregroundBlur_1777_5756"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1777_5756",
    x: 84.5158,
    y: 36.3674,
    width: 59.7926,
    height: 47.5699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.39833,
    result: "effect1_foregroundBlur_1777_5756"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1777_5756",
    x: 95.2912,
    y: 44.3889,
    width: 38.859,
    height: 30.9098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.67861,
    result: "effect1_foregroundBlur_1777_5756"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1777_5756",
    x1: 15.8565,
    y1: 19.5047,
    x2: 55.3782,
    y2: 140.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B589FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491707,
    stopColor: "#AF86FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738033,
    stopColor: "#866FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806CF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingBotLogo1);
export default __webpack_public_path__ + "static/media/TradingBotLogo_1.59dde2be27dd0e82836020c954f5c87f.svg";
export { ForwardRef as ReactComponent };